import { render, staticRenderFns } from "./DefaultContact.vue?vue&type=template&id=71dc6abc&scoped=true&"
import script from "./DefaultContact.vue?vue&type=script&lang=js&"
export * from "./DefaultContact.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContact.vue?vue&type=style&index=0&id=71dc6abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc6abc",
  null
  
)

export default component.exports